// getters
const adminRoles = state => state.adminRoles

export default {
  adminRoles
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/roles/getters.js